export const logged_user_routes = [
  {
    path: "/logged-user",
    component: () => import("../Main.vue"),
    name: "Meu Perfil"
  }
];

export default {};
